import {FontStorageState} from '../../../interfaces/screens/fontChanger';
import {store} from '../../../redux/store';
import {getFont, updateFont} from '../../../utils/storage';
import {setConfig} from '../../auth/login/reducer';

/**
 * this function to get news List as search results
 *
 * @return {TabNewItemType[]} result of news List
 */
export const updateAppFont = async (
  font?: FontStorageState,
  isInitialize?: boolean,
): Promise<boolean> => {
  try {
    let tempFont = font;
    if (isInitialize) {
      tempFont = getFont();
    } else if (tempFont) {
      updateFont(tempFont);
    }
    const {config} = store.getState().auth || {};
    if (!tempFont) {
      return false;
    }
    const tempConfig = {...(config || {}), font: tempFont};
    store.dispatch(setConfig(tempConfig));
    return true;
  } catch (error: any) {
    return false;
  }
};
